import { render, staticRenderFns } from "./my-post.vue?vue&type=template&id=74892755"
import script from "./my-post.vue?vue&type=script&lang=js"
export * from "./my-post.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports